module.exports = __webpack_public_path__ + "f25961dc47ea9c97796835bff784929f.pdf";